module.exports = __webpack_public_path__ + "static/media/start_scene1.176191fa.png";